import { render, staticRenderFns } from "./CustomerUserList.vue?vue&type=template&id=3804da26&scoped=true"
import script from "./CustomerUserList.vue?vue&type=script&lang=js"
export * from "./CustomerUserList.vue?vue&type=script&lang=js"
import style0 from "./CustomerUserList.vue?vue&type=style&index=0&id=3804da26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804da26",
  null
  
)

export default component.exports